import { AssetSingleSelection } from "src/components/AssetSelection";
import { useAssets } from "src/components/FetchConfig";
import { useTranslation } from "src/hooks";
import { FilterFieldsKeys } from "../../../../types/FilterFields";
import { usePageConfigProviderContext } from "src/features/PageConfigProvider";

function CurrencySingleSelection({
  value,
  onChange,
  chainName,
}: {
  value: string;
  onChange: (value: string) => void;
  chainName: string;
}) {
  const { translatePrefix } = usePageConfigProviderContext();

  const { t, tc } = useTranslation(translatePrefix);

  const { selectAssetNamesByChain } = useAssets();

  const allAssetNames = selectAssetNamesByChain({
    chain_name: chainName,
  });

  return (
    <AssetSingleSelection
      setChoice={onChange}
      choice={value}
      label={tc("phSelection", { fieldName: t(FilterFieldsKeys.Currency) })}
      allItems={allAssetNames}
    />
  );
}

export default CurrencySingleSelection;
